import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiClose, mdiClipboardTextOutline, mdiPrinter } from "@mdi/js";
import moment from "moment";

import { updateDataSearch } from "../../../actions/DanhSachDonDatHang";

import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import { Index_GetAllRoleInUser } from "actions/User";

import configs from "../../../constants/configs";
import {
  getUserLogin,
  getBranch,
  utilsOnChangeSelectTypeDate,
} from "utils/utils";

import SearchDonDatHang from "./SearchDonDatHang";
import TableDonDatHang from "./TableDonDatHang";
import FullScreenLoading from "../loading/FullScreenLoading";

export default function DonDatHang() {
  const dispatch = useDispatch();

  const listDonHang = useSelector((state) => state.listDanhSachDonDatHang);
  const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);

  const danhmuc = useSelector((state) => state.danhmuc);
  const { objConfigAll } = danhmuc;

  const user = useSelector((state) => state.user);
  const { AllRoleUser } = user;

  const [isLamTronTien, setLamTronTien] = useState(null);
  const [isConfigMaPO, setIsConfigMaPO] = useState(null);
  const [isConfigThongTinLSX, setIsConfigThongTinLSX] = useState(null);
  const [isEditDHCheckTrangThaiKho, setIsEditDHCheckTrangThaiKho] =
    useState(null);

  const [roleEditDH, setRoleEditDH] = useState(null);
  const [roleXoaDH, setRoleXoaDH] = useState(null);
  const [roleDuyetYeuCau, setRoleDuyetYeuCau] = useState(null);
  const [roleEditDHQuaNgay, setRoleEditDHQuaNgay] = useState(null);

  const [configLenhSanXuat, setConfigLenhSanXuat] = useState(null);
  const [isCheckInNhanh, setIsCheckInNhanh] = useState(false);

  const [isModalVisible, setModalVisible] = useState(false);
  const [selected, setSelected] = useState({});
  const [listTextSearch, setListTextSearch] = useState({ List: [] });

  useEffect(() => {
    dispatch(Index_GetConfigAllSTKey());
    dispatch(Index_GetAllRoleInUser({ username: getUserLogin().UserName }));
  }, []);

  useEffect(() => {
    if (
      objConfigAll.List.length > 0 &&
      isLamTronTien === null &&
      isConfigMaPO === null &&
      isConfigThongTinLSX === null &&
      isEditDHCheckTrangThaiKho === null
    ) {
      const configLamTronTien = objConfigAll.List.find(
        (e) =>
          e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase(),
      );

      setLamTronTien(true);
      if (configLamTronTien?.Value === "1") {
        setLamTronTien(false);
      }

      const configPO = objConfigAll.List.find(
        (e) => e.KeyID.toUpperCase() === configs.sKey.ConfigMaPO.toUpperCase(),
      );
      setIsConfigMaPO(configPO?.Value === "1");

      const configThongTinLSX = objConfigAll.List.find(
        (e) =>
          e.KeyID.toUpperCase() ===
          configs.sKey.ConfigThongTinLSX.toUpperCase(),
      );
      setIsConfigThongTinLSX(configThongTinLSX?.Value === "1");

      const configEditDHCheckTrangThaiKho = objConfigAll.List.find(
        (e) =>
          e.KeyID.toUpperCase() ===
          configs.sKey.EditOrderUpdateStore.toUpperCase(),
      );
      setIsEditDHCheckTrangThaiKho(
        configEditDHCheckTrangThaiKho?.Value === "1",
      );
    }
  }, [objConfigAll.List]);

  useEffect(() => {
    if (typeof AllRoleUser.List !== "undefined" && configLenhSanXuat === null) {
      const sRoleViewLSX = AllRoleUser.List.find(
        (e) => e.toUpperCase() === configs.sRole.LSX_TAOLENH.toUpperCase(),
      );
      setConfigLenhSanXuat(!!sRoleViewLSX);
    }

    if (
      typeof AllRoleUser.List !== "undefined" &&
      roleEditDH === null &&
      roleXoaDH === null &&
      roleDuyetYeuCau === null &&
      roleEditDHQuaNgay === null
    ) {
      setRoleEditDH(
        !!AllRoleUser.List.find(
          (e) => e.toUpperCase() === configs.sRole.BANHANG_SUADH.toUpperCase(),
        ),
      );

      setRoleXoaDH(
        !!AllRoleUser.List.find(
          (e) => e.toUpperCase() === configs.sRole.BANHANG_XOADH.toUpperCase(),
        ),
      );

      setRoleDuyetYeuCau(
        !!AllRoleUser.List.find(
          (e) => e.toUpperCase() === configs.sRole.HT_DUYETYEUCAU.toUpperCase(),
        ),
      );

      setRoleEditDHQuaNgay(
        !!AllRoleUser.List.find(
          (e) =>
            e.toUpperCase() ===
            configs.sRole.BANHANG_SUADHQUANGAY.toUpperCase(),
        ),
      );
    }
  }, [AllRoleUser.List]);

  const toggleModal = (status) => {
    setModalVisible(status);
  };

  const printList = () => {
    window.location.href =
      "/PrintsFile/InDanhSach?fromDate=" +
      moment(dataSearch.tuNgay || dataSearch.fromDate).format("YYYY-MM-DD") +
      "&toDate=" +
      moment(dataSearch.denNgay || dataSearch.toDate).format("YYYY-MM-DD") +
      "&sSearch=" +
      (dataSearch.sSearch || "") +
      "&sCustomerName=" +
      (dataSearch.sCustomerName || "") +
      "&iTrangThaiTruKho=" +
      (dataSearch.iTrangThaiTruKho || "") +
      "&iTrangThaiThanhToan=0" +
      "&iBranch=" +
      getBranch() +
      "&sBranch=" +
      (dataSearch.sBranch || "") +
      "&sNVKDUserName=" +
      (dataSearch.sNVKDUserName || "") +
      "&lstNhomKH=" +
      (dataSearch.lstNhomKH || "") +
      "&iLoaiDon=" +
      (dataSearch.iLoaiDon || "") +
      "&iLoaiDoiTac=0" +
      "&iPageIndex=1&iPageSize=200000" +
      "&typeDate=" +
      (dataSearch.typeDate || "1") +
      "&sTrangThai=" +
      (dataSearch.sTrangThai || "-1") +
      "&tab=orders";
  };

  const [dateFromNew, setDateFromNew] = useState(
    moment().subtract(90, "days").toDate(),
  );
  const [dateToNew, setDateToNew] = useState(new Date());
  const deleteTextSearch = (index, field) => {
    const obj = { ...listTextSearch };
    obj.List.splice(index, 1);
    setListTextSearch(obj);

    if (field === "sSearch") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          iPageIndex: 1,
          sSearch: "",
        }),
      );
    }

    if (field === "sTrangThai") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          iPageIndex: 1,
          sTrangThai: "0",
        }),
      );
    }

    if (field === "typeDate") {
      const thongtin = { ...dataSearch };
      thongtin.typeDate = "11";
      thongtin.iPageIndex = 1;
      utilsOnChangeSelectTypeDate(thongtin);
      setDateFromNew(moment().subtract(90, "days").toDate());
      setDateToNew(new Date());
      setSelected({
        key: "11",
        value: "Tùy chỉnh thời gian",
      });

      dispatch(
        updateDataSearch({
          ...thongtin,
          typeDate: "11",
          iPageIndex: 1,
          tuNgay: moment().subtract(90, "days").format("YYYY-MM-DD"),
          denNgay: moment().format("YYYY-MM-DD"),
        }),
      );
    }
  };

  return (
    <div className="don-page">
      {listDonHang.isProgress && <FullScreenLoading />}
      <div className="order-header-v2">
        <div className="order-title-v2">
          <span className="order-title-icon-v2">
            <Icon path={mdiClipboardTextOutline} size={1.2} />
          </span>

          <span>Đơn đặt hàng</span>
        </div>

        <div className="order-search-v2">
          <SearchDonDatHang
            isModalVisible={isModalVisible}
            toggleModal={toggleModal}
            selected={selected}
            setSelected={setSelected}
            listTextSearch={listTextSearch}
            setListTextSearch={setListTextSearch}
            dateFromNew={dateFromNew}
            setDateFromNew={setDateFromNew}
            dateToNew={dateToNew}
            setDateToNew={setDateToNew}
          />
        </div>

        <button className="order-print-btn-v2" onClick={printList}>
          <Icon path={mdiPrinter} size={1.2} />
          In
        </button>
      </div>

      {listTextSearch.List.length > 0 && (
        <div className="don-search-tags">
          {listTextSearch.List.map((item, index) => {
            if (!item.name && !item.sTrangThai) return null;

            const text =
              item.field === "typeDate"
                ? item.name === "1"
                  ? "Hôm nay"
                  : item.name === "2"
                    ? "Hôm qua"
                    : item.name === "3"
                      ? "Tuần này"
                      : item.name === "4"
                        ? "Tuần trước"
                        : item.name === "5"
                          ? "Tháng này"
                          : item.name === "6"
                            ? "Tháng trước"
                            : item.name === "7"
                              ? "Quý này"
                              : item.name === "8"
                                ? "Quý trước"
                                : item.name === "9"
                                  ? "Năm này"
                                  : item.name === "10"
                                    ? "Năm trước"
                                    : item.name === "11"
                                      ? `Từ ngày ${moment(item.tuNgay).format(
                                          "DD/MM/YYYY",
                                        )} đến ngày ${moment(item.denNgay).format("DD/MM/YYYY")}`
                                      : item.name
                : item.field === "sTrangThai"
                  ? item.sTrangThai === "-1"
                    ? "Trạng thái: tất cả"
                    : item.sTrangThai === "0"
                      ? "Trạng thái: chờ chốt"
                      : item.sTrangThai === "1"
                        ? "Trạng thái: đã chốt"
                        : item.sTrangThai === "2"
                          ? "Trạng thái: không chốt"
                          : item.sTrangThai === "3"
                            ? "Trạng thái: lên đơn 1 phần"
                            : item.sTrangThai === "4"
                              ? "Trạng thái: hoàn thành"
                              : ""
                  : item.name;

            if (!text) return null;

            return (
              <div className="don-search-tag" key={index}>
                {text}
                <button onClick={() => deleteTextSearch(index, item.field)}>
                  <Icon path={mdiClose} size={0.7} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      <TableDonDatHang
        configLenhSanXuat={configLenhSanXuat}
        isConfigMaPO={isConfigMaPO}
        isConfigThongTinLSX={isConfigThongTinLSX}
        isLamTronTien={isLamTronTien}
        roleEditDH={roleEditDH}
        isEditDHCheckTrangThaiKho={isEditDHCheckTrangThaiKho}
        isCheckInNhanh={isCheckInNhanh}
        setIsCheckInNhanh={setIsCheckInNhanh}
        roleXoaDH={roleXoaDH}
        roleDuyetYeuCau={roleDuyetYeuCau}
        roleEditDHQuaNgay={roleEditDHQuaNgay}
        listDonHang={listDonHang}
        dataSearch={dataSearch}
      />
    </div>
  );
}
